import moment from 'moment';

export default {
  isAfter(timeA, timeB) {
    if (!timeA || !timeB) return;
    return timeA.isAfter(timeB);
  },
  getDateDashFormat(time, format, isSourceUtcTime) {
    if (!time) return '';
    return isSourceUtcTime
      ? moment.utc(time).format(format ? format : 'YYYY-MM-DD')
      : moment(time).format(format ? format : 'YYYY-MM-DD');
  },
  setTimeToUtc(time) {
    if (!time) return '';
    return moment(time).utc();
  },
  startOf(time, format, unit) {
    if (!time) return '';
    return moment(time)
      .startOf(unit ? unit : 'day')
      .format(format ? format : 'YYYY-MM-DD HH:mm:ss');
  },
  endOf(time, format, unit) {
    if (!time) return '';
    return moment(time)
      .endOf(unit ? unit : 'day')
      .format(format ? format : 'YYYY-MM-DD HH:mm:ss');
  },
  getNextOnTheHour() {
    const currentTime = moment().add(1, 'hours');
    return this.startOf(currentTime, 'YYYY-MM-DD HH:mm:ssZ', 'hour');
  }
}